class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener(
      'keyup',
      (evt) => evt.code === 'Escape' && this.close()
    );

    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;

    this.getSectionsToRender().forEach((section) => {
      const target = document.getElementById(section.id);

      if (!target) return;

      const newHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );

      if (newHTML !== null) {
        target.innerHTML = newHTML;
      }
    });

    /*
     * IMPORTANT:
     *
     * We intentionally DO NOT replace #cart-icon-bubble here.
     *
     * Snap Stickers uses a custom cart icon inside header.liquid.
     * Shopify's default cart notification code used to replace
     * that custom SVG with the generic cart-icon-bubble section,
     * which caused the cart icon to disappear after Add to Cart.
     */

    this.updateSnapCartIndicator(parsedState);

    if (this.header) {
      this.header.reveal();
    }

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    if (!html) return null;

    const parsedHTML = new DOMParser().parseFromString(
      html,
      'text/html'
    );

    const selected = parsedHTML.querySelector(selector);

    return selected ? selected.innerHTML : null;
  }

  updateSnapCartIndicator(parsedState) {
    /*
     * Desktop custom utility-bar cart.
     */

    const desktopCart = document.getElementById('cart-icon-bubble');

    if (desktopCart) {
      let dot = desktopCart.querySelector('.ss-cart-has-items-dot');

      if (parsedState && parsedState.item_count > 0) {
        if (!dot) {
          dot = document.createElement('span');
          dot.className = 'ss-cart-has-items-dot';
          dot.setAttribute('aria-hidden', 'true');
          desktopCart.appendChild(dot);
        }
      } else if (dot) {
        dot.remove();
      }
    }

    /*
     * Mobile cart icon.
     */

    const mobileCart = document.getElementById(
      'cart-icon-bubble-mobile'
    );

    if (mobileCart) {
      let mobileDot = mobileCart.querySelector(
        '.ss-cart-has-items-dot'
      );

      if (parsedState && parsedState.item_count > 0) {
        if (!mobileDot) {
          mobileDot = document.createElement('span');
          mobileDot.className = 'ss-cart-has-items-dot';
          mobileDot.setAttribute('aria-hidden', 'true');
          mobileCart.appendChild(mobileDot);
        }
      } else if (mobileDot) {
        mobileDot.remove();
      }
    }
  }

  handleBodyClick(evt) {
    const target = evt.target;

    if (
      target !== this.notification &&
      !target.closest('cart-notification')
    ) {
      const disclosure = target.closest(
        'details-disclosure, header-menu'
      );

      this.activeElement = disclosure
        ? disclosure.querySelector('summary')
        : null;

      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define(
  'cart-notification',
  CartNotification
);